import { FatalDecoratorExistedError } from '../errors'
import { createDebounceDescriptor, debounce } from './debounce'

import type { DebounceAnnotation, DebounceOptions } from '../types'

function createDescriptor(
  proto: any,
  key: string,
  options: DebounceOptions = {}
): PropertyDescriptor {
  options.wait ??= 0
  options.maxWait ??= options.wait
  return createDebounceDescriptor(proto, key, options)
}

export const throttle: DebounceAnnotation<DebounceOptions> = (
  value,
  options = {}
) => {
  options.wait ??= 0
  options.maxWait ??= options.wait
  return debounce(value, options)
}

throttle._name = 'throttle'

throttle._tsDecorator = (proto, key, descriptor, options) => {
  if (descriptor !== undefined)
    throw new FatalDecoratorExistedError(throttle._name, key)
  return createDescriptor(proto, key, options)
}

throttle._esAccessorDecorator = (context, options) => {
  const descriptor = createDescriptor(undefined, String(context.name), options)
  return {
    get: descriptor.get,
    init: descriptor.set,
    set: descriptor.set
  }
}
